import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './components/Header25';
import Footer from './components/Footer25';

const TermsAndConditions25 = () => {
    const navigate = useNavigate();

    const sections = [
        {
            title: 'Acceptance of Terms',
            content: 'By accessing and using this website, you accept and agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree to these terms, please do not use our website or purchase our products. These terms apply to all visitors, users, and customers of the website.'
        },
        {
            title: 'Products & Pricing',
            content: 'All product descriptions, images, and specifications are provided for general information purposes. We strive for accuracy but do not guarantee that descriptions or pricing are error-free. Prices are listed in Indian Rupees (INR) and include applicable taxes unless stated otherwise. We reserve the right to modify prices without prior notice. Due to the handcrafted nature of our products, minor variations in color, texture, and pattern are natural and should be expected.'
        },
        {
            title: 'Orders & Payment',
            content: 'By placing an order, you are making an offer to purchase. All orders are subject to acceptance and availability. We accept payments via credit/debit cards, UPI, net banking, and cash on delivery (for select locations). Payment must be received in full before order dispatch. We use industry-standard encryption to protect your payment information.'
        },
        {
            title: 'Shipping & Delivery',
            content: 'We ship across India and to select international destinations. Delivery timelines are estimates and may vary based on location and product availability. Standard delivery within India typically takes 5-7 business days. Express shipping options are available at additional cost. We are not liable for delays caused by courier services or circumstances beyond our control.'
        },
        {
            title: 'Returns & Exchanges',
            content: 'We offer a 15-day return policy from the date of delivery. Products must be unworn, unwashed, and in original packaging with all tags attached. Custom-made or altered items cannot be returned. Refunds will be processed within 7-10 business days after receiving and inspecting the returned product. Please refer to our Shipping & Exchange page for detailed procedures.'
        },
        {
            title: 'Intellectual Property',
            content: 'All content on this website including but not limited to text, graphics, logos, images, designs, and software is the property of our brand and is protected by Indian and international copyright laws. You may not reproduce, distribute, or create derivative works without our express written permission.'
        },
        {
            title: 'User Accounts',
            content: 'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use. We reserve the right to terminate or suspend accounts that violate these terms.'
        },
        {
            title: 'Limitation of Liability',
            content: 'To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or products. Our total liability shall not exceed the amount paid by you for the specific product in question.'
        },
        {
            title: 'Governing Law',
            content: 'These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Mumbai, Maharashtra.'
        },
        {
            title: 'Modifications',
            content: 'We reserve the right to update or modify these Terms and Conditions at any time without prior notice. Changes will be effective immediately upon posting on this page. Your continued use of the website after any changes constitutes acceptance of the new terms.'
        },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
                .sahaj-terms * { box-sizing: border-box; }
                .sahaj-terms { font-family: 'IBM Plex Sans', sans-serif; background: #FFFFFF; color: #111111; }
                .sahaj-terms-heading { font-family: 'Space Grotesk', sans-serif; }
            `}</style>
            <div className="sahaj-terms" style={{ minHeight: '100vh' }}>
                <Header />

                {/* Hero */}
                <div style={{ background: '#111111', padding: '60px 0', marginTop: 80 }}>
                    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px' }}>
                        <h1 className="sahaj-terms-heading" style={{
                            fontSize: 48, fontWeight: 700, color: '#FFFFFF', margin: 0, letterSpacing: '-1px'
                        }}>
                            TERMS & CONDITIONS
                        </h1>
                        <p style={{ fontSize: 14, color: '#9CA3AF', marginTop: 12 }}>
                            Last updated: March 2026
                        </p>
                    </div>
                </div>

                <div style={{ maxWidth: 800, margin: '0 auto', padding: '60px 24px 80px' }}>
                    <p style={{ fontSize: 16, lineHeight: 1.8, color: '#6C757D', marginBottom: 48 }}>
                        Please read these Terms and Conditions carefully before using our website or purchasing products. These terms govern your use of our services and products.
                    </p>

                    {sections.map((section, idx) => (
                        <div key={idx} style={{
                            marginBottom: 40, paddingBottom: 40,
                            borderBottom: idx < sections.length - 1 ? '1px solid #DEE2E6' : 'none'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                                <span className="sahaj-terms-heading" style={{
                                    fontSize: 14, fontWeight: 700, color: '#0D7C66',
                                    background: '#E8F5F1', padding: '4px 12px',
                                    flexShrink: 0, marginTop: 4
                                }}>
                                    {String(idx + 1).padStart(2, '0')}
                                </span>
                                <div>
                                    <h2 className="sahaj-terms-heading" style={{
                                        fontSize: 22, fontWeight: 700, margin: '0 0 16px', letterSpacing: '-0.3px'
                                    }}>
                                        {section.title}
                                    </h2>
                                    <p style={{ fontSize: 15, lineHeight: 1.8, color: '#6C757D', margin: 0 }}>
                                        {section.content}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div style={{
                        background: '#F8F9FA', padding: 32, border: '1px solid #DEE2E6', marginTop: 20
                    }}>
                        <p style={{ fontSize: 14, color: '#6C757D', margin: '0 0 12px', lineHeight: 1.6 }}>
                            If you have any questions about these Terms and Conditions, please contact us.
                        </p>
                        <span
                            onClick={() => navigate('/template25/contact')}
                            style={{ fontSize: 14, color: '#0D7C66', fontWeight: 600, cursor: 'pointer' }}
                        >
                            Contact Us →
                        </span>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default TermsAndConditions25;
